export enum NoticeTypeEnum {
    GENERAL = 'GENERAL',
    ORGANIZATION_ARREARS = 'ORGANIZATION_ARREARS',
    QUOTE = 'QUOTE',
    SHIPPING_DISABLED = 'SHIPPING_DISABLED',
    LOGIN_DISABLED = 'LOGIN_DISABLED',
    NO_SERVICES_AVAILABLE = 'NO_SERVICES_AVAILABLE',
    NO_SERVICES_AVAILABLE_SMALL_PARCEL = 'NO_SERVICES_AVAILABLE_SMALL_PARCEL',
    NO_SERVICES_AVAILABLE_LTL = 'NO_SERVICES_AVAILABLE_LTL'
}